import { Body1 } from '@sainsburys-tech/luna-typography'
import getRelativeDate from '../../../utils/getRelativeDate'
import { IReportedByDescription } from '../../../types'

const ReportedByDescription = ({ reportedBy, dateReported, timeReported }: IReportedByDescription) => {
  return (
    <div id="s-reported-by-description">
      <Body1
        className="ln-u-color-grey"
        >
        Reported by {reportedBy}
        {dateReported
          ? `, on ${getRelativeDate({ dateTime: dateReported, type: "date"})}`
          : ""}
        {timeReported
          ? ` at ${getRelativeDate({ dateTime: timeReported, type: "time" })}`
          : ""}
      </Body1>
    </div>
  )
}

export default ReportedByDescription
